import { useEffect, useRef, useState } from "react";
import { ChromePicker, ColorResult, HSLColor } from "react-color";
import styles from "./ColorPicker.module.scss";
import { colorToCssValue } from "../../../utils/colorToCssValue";
import { IColor } from "../../../interfaces/Site";

interface IProps {
    handleChange: (value: IColor) => void;
    value: IColor;
    name: string;
    id: string;
    label?: string;
    disableAlpha: boolean;
    pickerPosition?: "LEFT" | "RIGHT";
}

export function ColorPicker(props: IProps) {
    const pickerWrapper = useRef<HTMLDivElement>(null);

    const [pickerOpen, setPickerOpen] = useState(false);
    const [currentValue, setCurrentValue] = useState<HSLColor>(props.value);

    const handleChange = (color: ColorResult) => {
        const colorFormatted: IColor = { ...color.hsl, a: color.hsl.a === undefined ? 1 : color.hsl.a };
        props.handleChange(colorFormatted);
    };

    const handleClick = (e: any) => {
        if (pickerWrapper.current && !pickerWrapper.current.contains(e.target)) {
            setPickerOpen(false);
        }
    };

    useEffect(() => {
        if (pickerOpen === true) {
            document.addEventListener("click", handleClick);
        } else {
            document.removeEventListener("click", handleClick);
        }

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [pickerOpen]);

    return (
        <div className={styles.wrapper}>
            {props.label ? (
                <div className={styles.labelWrapper}>
                    <label className={styles.label} htmlFor={props.id}>
                        {props.label}
                    </label>
                </div>
            ) : null}
            <div className={styles.pickerWrapper}>
                <div
                    className={styles.preview}
                    onClick={() => setPickerOpen(true)}
                    style={{ backgroundColor: colorToCssValue(props.value) }}
                ></div>
                <div
                    className={`${props.pickerPosition === "LEFT" ? styles.positionLeft : ""} ${styles.picker}`}
                    ref={pickerWrapper}
                >
                    {pickerOpen && (
                        <ChromePicker
                            onChangeComplete={handleChange}
                            onChange={(color) => setCurrentValue(color.hsl)}
                            color={currentValue}
                            disableAlpha={props.disableAlpha}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
